import type { PayloadAction } from '@reduxjs/toolkit';

import { Notification, SET_NOTIFICATION } from './types';

const initialState: Notification | null = null;

export function notificationReducer(
	state = initialState,
	action: PayloadAction<Notification | null>,
): Notification | null {
	switch (action.type) {
		case SET_NOTIFICATION:
			return action.payload;
		default:
			return state;
	}
}
